/* eslint-disable no-unused-vars */
import * as d3 from "d3";
import * as dc from 'dc';
import store from '@/store';
//import axios from "axios";
//import d3Tip from "d3-tip";
//import { legendColor } from "d3-svg-legend";
//import d3_timeseries from "../library/d3_timeseries.js";
import crossfilter from "crossfilter";
//import reset from "crossfilter";
//import MG from "metrics-graphics";
//import $ from "jquery";
//import * as topojson from "topojson";

/* Commented due to hardcoding
//Right-click event
function contextMenu(menu, openCallback) {
    // create the div element that will hold the context menu
    d3.selectAll('.d3-context-menu')
        .data([1])
        .enter()
        .append('div')
        .attr('class', 'd3-context-menu');

    // close menu
    d3.select('body')
      .on('click.d3-context-menu', function () {
            d3.select('.d3-context-menu').style('display', 'none');
      });

    // this gets executed when a contextmenu event occurs
    return function (data, index) {
        var elm = this;

        d3.selectAll('.d3-context-menu').html('');
        var list = d3.selectAll('.d3-context-menu').append('ul');
        list.selectAll('li').data(menu).enter()
            .append('li')
            .html(function (d) {
                return d.title;
            })
            .on('click', function (d) {
                d.action(elm, data, index);
                d3.select('.d3-context-menu').style('display', 'none');
            });

        // the openCallback allows an action to fire before the menu is displayed
        // an example usage would be closing a tooltip
        if (openCallback) openCallback(data, index);

        // display context menu
        d3.select('.d3-context-menu')
            .style('left', (d3.event.pageX - 2) + 'px')
            .style('top', (d3.event.pageY - 2) + 'px')
            .style('display', 'block');

        d3.event.preventDefault();
    }
} */

//var downloadData = [
//    {
//        title:'<a href="http://139.59.58.160:9998/#/customer-drilldown-dyn/G/G01" target="_blank" style="background-color:white;">Go For Drilldown Report</a>',
//        title:'<a style="background-color:white;">Go For Drilldown Report</a>',
//        action: function (elm, d) {
//            return d;
//        }
//    }
//]
/*
function format(x) {
    var str = String(x);
    var arr = [];
    var i = str.indexOf(".");
    var j;
    if (i === -1) {
        i = str.length;
    } else {
        for (j = str.length - 1; j > i; j--) {
            arr.push(str[j]);
        }
        arr.push(".");
    }
    i--;
    for (j = 0; i >= 0; i--, j++) {
        if (j > 2 && (j % 2 === 1)) {
            arr.push(",");
        }
        arr.push(str[i]);
    }
    return arr.reverse().join("");
}

function inrFormatter(num) {
    if (Math.abs(num) >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'HCr';
    }
    if (Math.abs(num) >= 10000000) {
        return (num / 10000000).toFixed(1).replace(/\.0$/, '') + 'Cr';
    }
    if (Math.abs(num) >= 100000) {
        return (num / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
    }
    if (Math.abs(num) >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    if (Math.abs(num) < 1000 && Math.abs(num)% 1 !== 0) {
        return num.toFixed(2);
    }
    return num;
}

var numberFormat = inrFormatter;
//var numberFormat = d3.format('.2s');
//var numberFormat = d3.format('.2s');

var fw_progressive_1way = d3.schemeCategory10;
//var fw_progressive_1way =  chart.y1colorRange;
var fw_progressive_2way = d3.schemeSet3;
var fw_waterfall=['#1f77b4','#90EE90','Green','#F08080','#d62728']
console.warn("color palette:", fw_progressive_2way)


//responsive screen code


//dcBarChart
//dcRowChart
//dcPieChart
//dcHeatmap
*/

function responsivefy(svg) {
    var container = d3.select(svg.node().parentNode),
        width = parseInt(svg.style('width')),
        height = parseInt(svg.style('height')),
        aspect = width / height;

    console.log("container in responsivefy",container,width,height);

    svg.attr('viewBox', '0 0 ' + width + ' ' + height)
        .attr('perserveAspectRatio', 'xMinYMid')
        .call(resize)

    d3.select(window).on('resize.' + container.attr('id'), resize);

    function resize() {
        var targetWidth = parseInt(container.style('width'))
        console.log("targetWidth",targetWidth);
        svg.attr('width', targetWidth )
        svg.attr('height', Math.round(targetWidth / aspect))
    }
    dc.redrawAll()
}

var test;
var homeData;
var rawData;

function inrFormatter(num) {

    if (store.state.fwMClient[0].numberSystem === 'Indian') {
        if (Math.abs(num) >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' HCr';
        }
        if (Math.abs(num) >= 10000000) {
            return (num / 10000000).toFixed(1).replace(/\.0$/, '') + ' Cr';
        }
        if (Math.abs(num) >= 100000) {
            return (num / 100000).toFixed(1).replace(/\.0$/, '') + ' L';
        }
        if (Math.abs(num) >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
            return num.toFixed(2);
        }
        return num;
    } else {
        if (Math.abs(num) >= 1000000000000) {
            return (num / 1000000000000).toFixed(1).replace(/\.0$/, '') + ' T';
        }
        if (Math.abs(num) >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' B';
        }
        if (Math.abs(num) >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + ' M';
        }
        if (Math.abs(num) >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
            return num.toFixed(2);
        }
        return num;
    }
}

function topNumbersGroupForAll(chartGroup) {
    let mt = chartGroup.toLowerCase()
    let topNumbersGrpAll = homeData.groupAll().reduce(
        function (p, v) {

            ++p.num;
            p.metric += parseInt(v[mt])
            return p;
        },
        function (p, v) {

            --p.num;
            p.metric -= parseInt(v[mt])
            return p;
        },
        function () {
            return {num: 0, metric: 0};
        });

    return topNumbersGrpAll
}

function addSearchFunctionality(divId, searchDimension, dataTable) {
    const searchId = `${divId.id}-search`;
    console.log("searchId",searchId);
    const searchInput = document.getElementById(searchId);

    if (searchInput) {
        searchInput.addEventListener('input', function() {
            const searchValue = this.value.toLowerCase();

            if (searchValue) {
                searchDimension.filterFunction(d => d.includes(searchValue));
            } else {
                searchDimension.filterAll();
            }

            dataTable.redraw();
        });
    }
}

function topNumbersGrp() {

    var topNumbersGrp = homeData.groupAll().reduce(
        function (p, v) {
            ++p.num;
            p.tm3 += parseInt(v.metric3);
            p.tm4 += parseInt(v.metric4);
            p.tgross += parseInt(v.metric3 - v.metric4);
            p.tm1 += parseInt(v.metric1);

            return p;
        },
        function (p, v) {
            --p.num;
            p.tm3 -= parseInt(v.metric3);
            p.tm4 -= parseInt(v.metric4);
            p.tgross -= parseInt(v.metric3 - v.metric4);
            p.tm1 -= parseInt(v.metric1);

            return p;
        },
        function () {
            return {num: 0, tm3: 0, tm4: 0, tgross: 0, tm1: 0};
        }
    );
    return topNumbersGrp
}


export default {
    //dc Bar chart function
    assignCrossfilterData: function (data) {
        test = "assigned in a function";
        homeData = crossfilter(data);
        rawData = data;
    },

    dcLineChart: function (chart, divId, alt) {
        console.log("from dcLine Chart", divId);

        let r2c2 = dc.compositeChart(divId);
        let r2c2Dimension = chart.dim;
        let r2c2Dimension1 = chart.dim2;

        let r2c2Dim = homeData.dimension((a) => a[r2c2Dimension.toLowerCase()]);
        let r2c2Group = chart.group;

        let r2c2Grp = r2c2Dim.group().reduceSum((a) => a[r2c2Group.toLowerCase()]);

        const groupData = [...new Set(rawData.map((d) => d[r2c2Dimension1]))].sort(d3.ascending);
        const groups = groupData.map((group) =>
            r2c2Dim.group().reduceSum((d) => (d[r2c2Dimension1] === group ? +d[r2c2Group] : 0))
        );

        const colors = d3.scaleOrdinal(d3.schemeCategory10);

        let xMin = d3.min(r2c2Grp.all(), (d) => d.key) || 0;
        let xMax = d3.max(r2c2Grp.all(), (d) => d.key) || 10;

        r2c2
            .width(chart.width)
            .height(chart.height)
            .transitionDuration(1000)
            .margins(chart.margin || { top: 10, right: 50, bottom: 30, left: 50 })
            .dimension(r2c2Dim)
            .brushOn(false)
            .shareTitle(false)
            .x(d3.scaleLinear().domain([xMin, xMax]))
            .elasticY(true)
            .mouseZoomable(true)
            // .title((a) => `${a.key}: ${inrFormatter(a.value)}`)
            .legend(dc.legend().x(chart.width - 110).y(3).itemHeight(7).gap(5))
            .renderHorizontalGridLines(true)
            .renderVerticalGridLines(true)
            // .transitionDuration(500)
            // .transitionDelay(250)
            .useViewBoxResizing(true)
            .compose(
                groupData.map((dim1Name, i) =>
                    dc.lineChart(r2c2)
                        .dimension(r2c2Dim)
                        .renderArea(true)
                        .renderDataPoints(true)
                        .colors(colors(i))
                        .group(groups[i], dim1Name)
                        .title((a) => {
                            // return chart.y + " " + a.key + ": " + inrFormatter(a.value) + " " + chart.unit;
                            return chart.y + " " + a.key + ": " + inrFormatter(a.value);
                        })
                )
            )

            .yAxis().tickFormat((d) => inrFormatter(d));

        r2c2.on('pretransition', function (chart) {
            chart
                .selectAll('.x.axis text')
                .style('text-anchor', 'end')
                .attr('dx', '-0.8em')
                .attr('dy', '-0.5em')
                .attr('transform', 'rotate(-90)');
        });


        r2c2.render();

        // d3.select(divId).selectAll('svg').call(responsivefy);
        chart.chartElem = r2c2;
    },


    dcBubbleChart: function (chart, divId, alt) {
        // console.log("home data  in bubble chart",chart);
        // Create a bubble chart instance
        let bubbleChart = dc.bubbleChart(divId);

        // Define the dimension based on the chart configuration
        let bubbleDimension = chart.dim;
        // console.log("bubbleDimension",bubbleDimension);
        if (bubbleDimension == 'dim4_qq') {
            var r2c3Dim = homeData.dimension(function (a) {
                return a.dim4_yyyy + '-Q' + a.dim4_qq;
            });
        } else if (bubbleDimension == 'dim4_mm') {
            r2c3Dim = homeData.dimension(function (a) {
                return a.dim4_yyyy + '-' + a.dim4_mm;
            });
        } else if (bubbleDimension == 'dim4_name') {
            r2c3Dim = homeData.dimension(function (a) {
                return a.dim4_yyyy + '-' + a.dim4_name;
            });
        } else {
          r2c3Dim = homeData.dimension(function (a) {
                return a[bubbleDimension.toLowerCase()];
            });
        }

        let bubbleGroup = chart.group;
        let r2c3Grp = r2c3Dim.group().reduceSum(function (a) {
            return a[bubbleGroup.toLowerCase()]
        });

// Compute max value for radius scaling
        let maxValue = d3.max(r2c3Grp.all(), d => d.value) || 1;
        let maxRadius = Math.sqrt(maxValue) * 0.5; // Adjust radius scaling factor

        // Determine X and Y domain dynamically based on data
        let xMin = d3.min(r2c3Grp.all(), d => d.key) || 0;
        let xMax = d3.max(r2c3Grp.all(), d => d.key) || 10;
        let yMin = d3.min(r2c3Grp.all(), d => d.value) || 0;
        let yMax = d3.max(r2c3Grp.all(), d => d.value) || 10;

        let yDomain = [yMin - 0.1*(yMax - yMin), yMax + 0.5*(yMax - yMin)]
        // console.log("yDomain",yDomain);

        // Configure the bubble chart
        bubbleChart
            .dimension(r2c3Dim)
            .group(r2c3Grp)
            .width(chart.width) // Default width if not provided
            .height(chart.height) // Default height if not provided
            .margins(chart.margin || { top: 10, right: 50, bottom: 30, left: 50 }) // Default margins if not provided
            .x(d3.scaleLinear().domain([xMin - 1, xMax + 1])) // Expand X range slightly
            .y(d3.scaleLinear().domain(yDomain)) // Adjusted Y range with padding
            .r(d3.scaleLinear().domain([0, maxRadius]))
            .radiusValueAccessor(d => Math.sqrt(d.value)) // Limit bubble size
            .minRadiusWithLabel(5) // Set minimum bubble radius
            .xAxisLabel(chart.y) // Set x-axis label
            .yAxisLabel(chart.x) // Set y-axis label
            .renderLabel(true)
            .renderTitle(true)
            .title(function (d) {
                return d.key + ": " + inrFormatter(d.value); // Tooltip title
            })
            .elasticRadius(true) // Allow radius to scale dynamically
            .maxBubbleRelativeSize(0.1) // Set maximum bubble size
            .renderlet(function (chart) {
                chart.selectAll('g.x text')
                    .attr('transform', 'translate(' + (chart.data.vizSpecific1 || 0) + ', ' + (chart.data.vizSpecific2 || 0) + ') rotate(' + (chart.data.vizSpecific3 || 0) + ')');
            })
            .controlsUseVisibility(true)
            .useViewBoxResizing(true)
            .yAxis().tickFormat(d => inrFormatter(d)); // Apply scaling here;
        // Assign the chart element to the chart object
        chart.chartElem = bubbleChart;

        // Render the chart
        bubbleChart.render();
    },


    dcBarChart: function (chart, divId, alt) {
       // console.log("dcBarChart",chart)
        //  assignTest()
        let r2c1 = dc.barChart(divId)
        let r2c1Dimension = chart.dim

        if (r2c1Dimension == 'dim4_qq') {
            var r2c1Dim = homeData.dimension(function (a) {
                return a.dim4_yyyy + '-Q' + a.dim4_qq;
            });
        } else if (r2c1Dimension == 'dim4_mm') {
            r2c1Dim = homeData.dimension(function (a) {
                return a.dim4_yyyy + '-' + a.dim4_mm;
            });
        } else if (r2c1Dimension == 'dim4_name') {
            r2c1Dim = homeData.dimension(function (a) {
                return a.dim4_yyyy + '-' + a.dim4_name;
            });
        } else {
            r2c1Dim = homeData.dimension(function (a) {
                return a[r2c1Dimension.toLowerCase()];
            });

        }

        let r2c1Group = chart.group

        if (r2c1Group.includes("-")) {
            let r2c1Grps = r2c1Group.split("-")

            var r2c1Grp = r2c1Dim.group().reduceSum(function (a) {
                return a[r2c1Grps[0].toLowerCase()] - a[r2c1Grps[1].toLowerCase()]
            });
        } else {
            r2c1Grp = r2c1Dim.group().reduceSum(function (a) {
                return a[r2c1Group.toLowerCase()]
            });
        }

        r2c1.yAxis().tickFormat(inrFormatter)
        r2c1.xAxis().tickFormat(d => {
            if (d.length > 10)
                return d.substring(0, 10) + '...'
            else
                return d
        })
        r2c1
            .margins(chart.margin)
            .width(chart.width)
            .height(chart.height)
            .dimension(r2c1Dim)
            .group(r2c1Grp)
            //            .valueAccessor((a) => {
            //                return (a.value / chart.div).toFixed(2);
            //            }) /* commented due to issue: bars are showing equal height*/
            .keyAccessor(function (a) {
                return a.key
            })
            .x(d3.scaleBand())
            .xUnits(dc.units.ordinal)
            .gap(1)
            .centerBar(false)
            .elasticY(true)
            .brushOn(false)
            .renderLabel(false)
            .renderTitle(true)
            .useViewBoxResizing(true)
            .turnOnControls(true)
            .controlsUseVisibility(true)
            .title((a) => {
                // return chart.y + " " + a.key + ": " + inrFormatter(a.value) + " " + chart.unit;
                return chart.y + " " + a.key + ": " + inrFormatter(a.value);
            })
            .renderlet(function (d) {
                d.selectAll('g.x text')
                    //.attr('transform', 'translate(-15, -30) rotate(-90)')
                    .attr('transform', 'translate(' + chart.data.vizSpecific1 + ', ' + chart.data.vizSpecific2 + ') rotate(' + chart.data.vizSpecific3 + ')')
            });


        r2c1.render();

        // d3.select(divId).selectAll("svg").call(responsivefy);
        chart.chartElem = r2c1
    },

// dc dcBarChartBrush function

    dcBarChartBrush: function (chart, divId, alt) {
        // console.log("from dcBarchartBrush", chart);

        // Mapper class to handle key-to-index and index-to-key mappings
        class Mapper {
            constructor(keys) {
                this._int2ord = [];
                this._ord2int = {};

                keys.forEach(key => {
                    if (!Object.prototype.hasOwnProperty.call(this._ord2int, key)) {
                        this._ord2int[key] = this._int2ord.length;
                        this._int2ord.push(key);
                    }
                });
            }

            ord2int(ord) {
                return this._ord2int[ord];
            }

            int2ord(i) {
                return this._int2ord[i];
            }

            length() {
                return this._int2ord.length;
            }
        }

        // Create the bar chart
        let r2c1 = dc.barChart(divId);
        let r2c1Dimension = chart.dim;

        // Get unique keys for the dimension and sort them
        const keys = rawData.map(d => d[r2c1Dimension]).sort((a, b) => d3.ascending(a, b));
        const mappings = new Mapper(keys);

        // Create the dimension using the Mapper
        var r2c1Dim = homeData.dimension(function (a) {
            return mappings.ord2int(a[r2c1Dimension.toLowerCase()]);
        });

        // Create the group for the chart
        let r2c1Group = chart.group;
        var r2c1Grp = r2c1Dim.group().reduceSum(function (a) {
            return a[r2c1Group.toLowerCase()];
        });

        // Format the y-axis ticks
        r2c1.yAxis().tickFormat(inrFormatter);

        // Format the x-axis ticks to handle long labels
        r2c1.xAxis().tickFormat(d => {
            if (d.length > 10)
                return d.substring(0, 10) + '...';
            else
                return d;
        });

        // Set the linear domain for the x-axis
        var linear_domain = [-0.5, mappings.length() - 0.5];

        // Configure the bar chart
        r2c1
            .width(chart.width).height(chart.height)
            .margins(chart.margin)
            .x(d3.scaleLinear().domain(linear_domain)) // Use a linear scale for the x-axis
            .xUnits(dc.units.integers) // Set x-units to integers
            .centerBar(true) // Center the bars
            .elasticY(true) // Allow the y-axis to adjust dynamically
            .brushOn(true) // Enable the brush feature
            .dimension(r2c1Dim) // Set the dimension
            .group(r2c1Grp) // Set the group
            .useViewBoxResizing(true)
            .title(kv => mappings.int2ord(kv.key)) // Set the title for each bar
            .on('renderlet', function(chart) {
                chart.selectAll('rect').on("click", function(d) {
                    console.log("click!", d);
                });
            });

        r2c1.on('pretransition', function(chart) {
            let brushBegin = [], brushEnd = [];
            if(chart.filter()) {
                brushBegin = [chart.filter()[0]];
                brushEnd = [chart.filter()[1]];
            }
            let beginLabel = chart.select('g.brush')
                .selectAll('text.brush-begin')
                .data(brushBegin);
            beginLabel.exit().remove();
            beginLabel = beginLabel.enter()
                .append('text')
                .attr('class', 'brush-begin')
                .attr('text-anchor', 'end')
                .attr('dominant-baseline', 'text-top')
                .attr('fill', 'black')
                .attr('y', chart.margins().top)
                .attr('dy', 4)
                .merge(beginLabel);
            beginLabel
                .attr('x', d => chart.x()(d))
                .text(d => d.toFixed(2));
            let endLabel = chart.select('g.brush')
                .selectAll('text.brush-end')
                .data(brushEnd);
            endLabel.exit().remove();
            endLabel = endLabel.enter()
                .append('text')
                .attr('class', 'brush-end')
                .attr('text-anchor', 'begin')
                .attr('dominant-baseline', 'text-top')
                .attr('fill', 'black')
                .attr('y', chart.margins().top)
                .attr('dy', 4)
                .merge(endLabel);
            endLabel
                .attr('x', d => chart.x()(d))
                .text(d => d.toFixed(2));
        })

        // Set x-axis tick values and format them
        r2c1.xAxis().tickValues(d3.range(mappings.length())).tickFormat(function (d) {
            if ((mappings.int2ord(d)).length > 10)
                return (mappings.int2ord(d)).substring(0, 10) + '...';
            else
                return (mappings.int2ord(d));
        });

        // Assign the chart to the chart element
        chart.chartElem = r2c1;

        // Render the chart
        r2c1.render();
    },

    // dc row chart function
    dcRowChart: function (chart, divId, alt) {
        let r2c2 = dc.rowChart(divId)

        let r2c2Dimension = chart.dim
        let r2c2Dim = homeData.dimension(function (a) {
            return a[r2c2Dimension.toLowerCase()]
        });

        let r2c2Group = chart.group
        let r2c2Grp = r2c2Dim.group().reduceSum(function (a) {
            return a[r2c2Group.toLowerCase()]
        });

        r2c2
            .width(chart.width)
            .height(chart.height)
            .dimension(r2c2Dim)
            .group(r2c2Grp)
            .valueAccessor((a) => {
                return (a.value / chart.div);
            })
            .gap(1)
            .renderLabel(true)
            .title((a) => {
                // return chart.y + " " + a.key + ": " + (a.value / chart.div).toFixed(2) + " " + chart.unit
                return a.key + ": " + inrFormatter(a.value)
            })
            .renderTitle(true)
            .useViewBoxResizing(true)
            .controlsUseVisibility(true)
            .xAxis.ticks = 4;

        chart.chartElem = r2c2
        r2c2.render();
    },

    // dc Pie chart function
    dcPieChartWithoutLabel: function (chart, divId, alt) {
        let r2c3 = dc.pieChart(divId)

        let r2c3Dimension = chart.dim
        let r2c3Dim = homeData.dimension(function (a) {
            return a[r2c3Dimension.toLowerCase()];
        });

        let r2c3Group = chart.group
        let r2c3Grp = r2c3Dim.group().reduceSum(function (a) {
            return a[r2c3Group.toLowerCase()]
        });
        let radius = 0;
        if (chart.data.vizSpecific1 != null) {
            radius = chart.data.vizSpecific1;
        } else radius = 40;

        r2c3
            .width(chart.width)
            .height(chart.height)
            .dimension(r2c3Dim)
            .group(r2c3Grp)
            .valueAccessor((a) => {
                return (a.value / chart.div).toFixed(2);
            })
            .slicesCap(10)
            .innerRadius(radius)
            .useViewBoxResizing(true)
            .controlsUseVisibility(true)
            //            .minAngleForLabel(0)
            .title((a) => {
                // return a.key + ": " + (a.value / chart.div).toFixed(2) + " " + chart.unit;
                return a.key + ": " + inrFormatter(a.value);
            })
        chart.chartElem = r2c3
        r2c3.render();
    },
    dcPieChart: function (chart, divId, alt) {
        let r2c3 = dc.pieChart(divId)

        let r2c3Dimension = chart.dim
        let r2c3Dim = homeData.dimension(function (a) {
            return a[r2c3Dimension.toLowerCase()];
        });

        let r2c3Group = chart.group
        let r2c3Grp = r2c3Dim.group().reduceSum(function (a) {
            return a[r2c3Group.toLowerCase()]
        });
        let radius = 0;
        if (chart.data.vizSpecific1 != null) {
            radius = chart.data.vizSpecific1;
        } else radius = 40;

        r2c3
            .width(chart.width)
            .height(chart.height)
            .dimension(r2c3Dim)
            .group(r2c3Grp)
            .valueAccessor((a) => {
                return (a.value / chart.div).toFixed(2);
            })
            .slicesCap(10)
            .innerRadius(radius)
            .controlsUseVisibility(true)
            .useViewBoxResizing(true)
            // .useViewBoxResizing(true)
            .minAngleForLabel(0.01)// default 0.5, if 0 mentioned labels are visible even if data is zero. Any slice with a smaller angle will not display a slice label.
            .title((a) => {
                // return a.key + ": " + (a.value / chart.div).toFixed(2) + " " + chart.unit;
                return a.key + ": " + inrFormatter(a.value);
            })

            .on('renderlet', function (chart) {
                chart.selectAll('text.pie-slice')
                    .attr('transform', function (d) {
                        var translate = d3.select(this).attr('transform');
                        var ang = ((d.startAngle + d.endAngle) / 2 * 180 / Math.PI) % 360;
                        if (ang < 180) ang -= 90; else ang += 90;
                        return translate + ' rotate(' + ang + ')';
                    });
            });
        chart.chartElem = r2c3
        r2c3.render();
    },
    dcPieChartLabelwithLine: function (chart, divId, alt) {
        let r2c3 = dc.pieChart(divId)

        let r2c3Dimension = chart.dim
        let r2c3Dim = homeData.dimension(function (a) {
            return a[r2c3Dimension.toLowerCase()];
        });

        let r2c3Group = chart.group
        let r2c3Grp = r2c3Dim.group().reduceSum(function (a) {
            return a[r2c3Group.toLowerCase()]
        });
        let radius = 0;
        if (chart.data.vizSpecific1 != null) {
            radius = chart.data.vizSpecific1;
        } else radius = 40;

        r2c3
            .width(chart.width)
            .height(chart.height)
            .dimension(r2c3Dim)
            .group(r2c3Grp)
            .valueAccessor((a) => {
                return (a.value / chart.div).toFixed(2);
            })
            .slicesCap(10)
            .innerRadius(radius)
            .controlsUseVisibility(true)
            .useViewBoxResizing(true)
            .minAngleForLabel(0)
            .externalLabels(30)
            .externalRadiusPadding(30)
            .drawPaths(true)
            .title((a) => {
                // return a.key + ": " + (a.value / chart.div).toFixed(2) + " " + chart.unit;
                return a.key + ": " + inrFormatter(a.value);
            })

            .on('renderlet', function (chart) {
                chart.selectAll('text.pie-slice')
                    .attr('transform', function (d) {
                        var translate = d3.select(this).attr('transform');
                        var ang = ((d.startAngle + d.endAngle) / 2 * 180 / Math.PI) % 360;
                        if (ang < 180) ang -= 90; else ang += 90;
                        return translate + ' rotate(' + ang + ')';
                    });
            });
        chart.chartElem = r2c3
        r2c3.render();
    },
    // dc heatmap chart function
    dcHeatmap: function (chart, divId, alt) {
        let r3c2 = dc.heatMap(divId)
        let r3c2Dimension1 = chart.dim
        let r3c2Dimension2 = chart.dim2
        let r3c2Dim = homeData.dimension(function (a) {
            return [a[r3c2Dimension1.toLowerCase()], a[r3c2Dimension2.toLowerCase()]];
        }); // check with Abur Rahman on data

        let r3c2Group = chart.group
        let r3c2Grp = r3c2Dim.group().reduceSum(function (a) {
            return a[r3c2Group.toLowerCase()]
        });
        //   let r3c2Color = chart.y1color

        r3c2
            .width(chart.width)
            .height(chart.height)
            .margins(chart.margin)
            .dimension(r3c2Dim)
            .group(r3c2Grp)
            .keyAccessor(function (a) {
                return a.key[1];
            })
            .valueAccessor(function (a) {
                return a.key[0];
            })
            .colorAccessor(function (a) {
                return a.value;
            })
            .controlsUseVisibility(true)
            .useViewBoxResizing(true)
            .title((a) => {
                return `${chart.y} : ${a.key[0]}
            ${chart.x} : ${a.key[1]}
            ${chart.y} :  ${inrFormatter(a.value)}`
                // ${chart.y} :  ${inrFormatter(a.value)} ${(a.value / chart.div).toFixed(2)}  ${chart.unit}`
            })
            // .colors(r3c2Color)
            .colors(["#E2F2FF", "#C4E4FF", "#9ED2FF", "#81C5FF", "#6BBAFF", "#51AEFF", "#36A2FF", "#1E96FF", "#0089FF", "#0061B5"])
            .calculateColorDomain();

        chart.chartElem = r3c2
        r3c2.render();
    },
    dcNumberDisplay: function (chart, divId) {
        let r1c1 = dc.numberDisplay(divId)
        let r1c1Group = chart.group
        r1c1
            //.formatNumber(d3.format(".3s"))
            .formatNumber(inrFormatter)
        if (r1c1Group.includes("-")) {
            r1c1.valueAccessor((d) => {
                return (d.tgross / chart.div).toFixed(2);
            })
                .group(topNumbersGrp()) /// find a way to do here or moving to Vue js is better
        } else {
            r1c1.valueAccessor((d) => {
                return (d.metric / chart.div).toFixed(2);
            })
                .group(topNumbersGroupForAll(r1c1Group))
                .useViewBoxResizing(true);
        }

        r1c1.render();
    },
// dc data table chart function
    dcDataTable: function (chart, divId) {
       // console.log("Chart from dcDatatable", chart);

        // Create the data table instance
        let dataTable = dc.dataTable(divId);

        let r2c2Dimension = chart.dim;
        let r2c2Dim = homeData.dimension(function (a) {
            return a[r2c2Dimension.toLowerCase()];
        });

        // Track current sort state
        let currentSort = {
            column: Object.keys(chart.columnHeader)[0],
            direction: 'ascending'
        };

        // Create a dimension for searching
        const allDim = homeData.dimension(d => Object.values(d).join(' ').toLowerCase());

        const columnDefs = Object.keys(chart.columnHeader).map(key => {
            const columnKey = chart.columnHeader[key];
            return {
                label: key,
                field_name: columnKey,
                sort_state: key === currentSort ? "ascending" : "none",
                format: (d) => columnKey.startsWith("metric") ? inrFormatter(d[columnKey]) : d[columnKey],
                className: key === currentSort.column ? "text-right sorted-column" : "text-left"
            };
        });

        // Configure the data table - USE columnFunctions here
        dataTable
            .width(chart.width)
            .height(chart.height)
            .dimension(r2c2Dim)
            .size(Infinity)
            .columns(columnDefs)  // Use the array of functions here
            .useViewBoxResizing(true)
            .showSections(false)
            .sortBy(d => d[columnDefs[0].field_name])
            .order(d3.ascending);

        // Add search functionality
      addSearchFunctionality(divId, allDim, dataTable);

        // Handle header clicks for sorting
        dataTable.on('postRender', function(table) {
            const tableContainer = d3.select(divId);
            const headers = tableContainer.select('thead').selectAll('th');

            // Store columnDefs in DOM elements for later access
            headers.nodes().forEach((node, index) => {
                node._columnDef = columnDefs[index];
            });

            headers.on('click', function() {
                const columnDef = this._columnDef;
                const columnIndex = Array.from(this.parentNode.children).indexOf(this);
                const clickedColumn = Object.keys(chart.columnHeader)[columnIndex];

                if (!columnDef) return; // safety check

                // Clear previous sort indicators
                tableContainer.selectAll('th').classed('sorted-column', false);

                // Toggle direction if clicking the same column
                if (currentSort.column === clickedColumn) {
                    currentSort.direction = currentSort.direction === 'ascending' ? 'descending' : 'ascending';
                } else {
                    // New column - default to ascending
                    currentSort.column = clickedColumn;
                    currentSort.direction = 'ascending';
                }

                // Toggle sort direction if same column
                if (columnDef.sort_state !== "none") {
                    columnDef.sort_state = columnDef.sort_state === "ascending" ? "descending" : "ascending";
                } else {
                    // New column - set to ascending
                    columnDefs.forEach(col => col.sort_state = "none");
                    columnDef.sort_state = "ascending";
                }

                // Update the table sorting
                dataTable
                    .sortBy(datum => datum[columnDef.field_name])
                    .order(columnDef.sort_state === "ascending" ? d3.ascending : d3.descending)
                    .redraw();

                // Highlight current sorted column
                d3.select(this).classed('sorted-column', true);
            });

        });

        // Update sort indicators and fixed header on redraw
        dataTable.on('pretransition', function(table) {
            const tableContainer = d3.select(divId)
                .classed("dc-data-table-container", true)
                .style("max-height", "400px") // Set the height of the scrollable area
                .style("overflow-y", "auto")
                .style("display", "block");

            const tableEl = tableContainer.select('table');

            // Remove any existing fixed header
            tableContainer.selectAll('.fixed-header').remove();

            const headers = tableContainer.select('thead').selectAll('th');

            // Clear all highlights and sort indicators
            headers.classed('sorted-column', false);
            headers.selectAll('.sort-indicator').remove();

                const thead = tableEl.select('thead');
                const tbody = tableEl.select('tbody');

            // Find and highlight the current sorted column
            const columnIndex = Object.keys(chart.columnHeader).indexOf(currentSort.column);
            if (columnIndex >= 0) {
                const sortedHeader = headers.filter((d, i) => i === columnIndex);

                // Add highlight class
                sortedHeader.classed('sorted-column', true);

                // Add sort indicator
                sortedHeader.append('span')
                    .classed('sort-indicator', true)
                    .style('margin-left', '5px')
                    .html(currentSort.direction === 'ascending'
                        ? '<i class="fas fa-arrow-up" style="color: #4CAF50;"></i>'
                        : '<i class="fas fa-arrow-down" style="color: #F44336;"></i>');
            }

                // Create scrollable container
                tableContainer
                    .classed("dc-data-table-container", true)
                    .style('max-height', '400px')
                    .style('overflow-y', 'auto')
                    .style('display', 'block');

                    const fixedHeader = tableContainer
                        .insert('div', ':first-child')
                        .classed('fixed-header', true)
                        .style("width", "100%")
                        .style('overflow', 'hidden')
                        .style('position', 'sticky')
                        .style('top', '0')
                        .style('z-index', '1')
                        .style('background-color', '#fff');

                    // fixedHeader.append(() => thead.node());

                    tbody.style('display', 'block')
                        .style('overflow-y', 'auto')
                        .style('max-height', '300px');
        });

        // Render the table
        dataTable.render();
    },


}